import { BrowserRouter, Route, Routes } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SharedDataProvider } from "./providers/SharedDataProvider";
import PageNotFound from "src/pages/PageNotFound";
import AppLayout from "./layout/AppLayout";
import { Toaster } from "sonner";
import {
  AlertTriangle,
  Check32,
  Info32,
} from "./assets/mapfre-icons-components";
import { ReactErrorBoundary } from "./components/error-boundary";
import { CookieConsent } from "./components/shared/CookieConsent";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient();

function App() {
  return (
    <ReactErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route
              path=":token/*"
              element={
                <ReactErrorBoundary>
                  <SharedDataProvider>
                    <AppLayout />
                  </SharedDataProvider>
                </ReactErrorBoundary>
              }
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          icons={{
            success: <Check32 className="text-state-success size-6" />,
            info: <Info32 className="text-state-info size-6" />,
            error: <AlertTriangle className="text-state-error size-6" />,
          }}
          toastOptions={{
            classNames: {
              title: "pl-4",
              description: "pl-4",
              icon: "pl-1",
            },
          }}
        />
        <CookieConsent />
        <ReactQueryDevtools initialIsOpen={false} position="right" />
      </QueryClientProvider>
    </ReactErrorBoundary>
  );
}

export default App;
